import React, { forwardRef, ComponentClass } from 'react';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import { Csat } from './csat';
import { CsatStatus } from './status';
import { TaskCsatTitle } from './title';

export type CsatProps = ClassNamePropsWithChildren<
  React.ElementType<HTMLDivElement>
>;

type TaskCsatType = ComponentClass<CsatProps> & {
  Detail: typeof Csat;
  Title: typeof TaskCsatTitle;
  Status: typeof CsatStatus;
};

const TaskCsat: TaskCsatType = forwardRef(
  () => null,
) as unknown as TaskCsatType;

TaskCsat.Detail = Csat;
TaskCsat.Title = TaskCsatTitle;
TaskCsat.Status = CsatStatus;

export { TaskCsat };
